import React from 'react'
// import ReactDOM from 'react-dom'
import { Store } from 'redux'
import { configureStore } from './store'
import { createMemoryHistory } from 'history';
import { fetchApiPollingTimeInterval } from 'api/sagas/index'
import { assignApiPollingTimeInterval } from './actions'
import { createRoot } from 'react-dom/client';

const history = createMemoryHistory()
export interface StoreAndContainer { store: Store<RootState>, element: Element } // Update the type of the store
const getScoreboardStore = (scoreboardRenderRoot: Element): StoreAndContainer => {
    // tslint:disable-next-line:class-name
    const controlId = parseInt(scoreboardRenderRoot.getAttribute('data-cid')!, 10)
    const initialState = { config: { controlId: controlId, scoreboardTypeId: 0 } }
    const store = configureStore(history, initialState)
    return {
        store,
        element: scoreboardRenderRoot,
    }
}
export const getScoreboardStores = (document: Document) => {

    const controls: Element[] = Array.from(document.querySelectorAll('.scoreboards-render-root'))

    const storeAndContainer = controls.map(getScoreboardStore);
    fetchApiPollingTimeInterval().then((response) => {
        const timeInterval: number = response.data;
        storeAndContainer.map((storeModel) => {
            storeModel.store.dispatch(assignApiPollingTimeInterval(timeInterval))
        })
        return storeAndContainer;
    })

    return storeAndContainer;
};


export const renderScoreboard = (Component: React.ComponentType<{ store: StoreAndContainer['store'] }>, value: StoreAndContainer) => {
    const root = createRoot(value.element);
    root.render(<Component store={value.store} />);
};
export interface ScoreboardCount { count: number }

export const compareCounts = (currentCount: number, previousCount: ScoreboardCount, render: (document: Document) => void) => {
    if (currentCount !== previousCount.count) {
        previousCount.count = currentCount
        render(document)
    }
}
